// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2K4z9","right":"Footer_right__QKe50","buttons":"Footer_buttons__2LLFY"};